import styled from "styled-components";

export const TMDLStyled = styled.div`
  margin-top: 14px;
`;
